import { ArrowRight } from "@mui/icons-material";
import { FC, MouseEventHandler, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { SVG_MUI } from "@ryde/assets";
import { ModalDialog, MuiButton } from "@ryde/controls";
import { useModalConfirm } from "@ryde/redux";
import { Log } from "@ryde/shared";

import { DashboardModalContent } from "../../dashboard/dashboard.components";

export const ButtonsTestPageWrapperStyled = styled.div`
  padding: 40px 40px;
`;

const RobotoCondensedPanelStyled = styled.p`
  font-family: "Roboto Condensed";
`;
const StyledModalButtonContainer = styled.div`
  padding: 20px;
`;

export const ButtonsTestPanel: FC = () => {
  const { t } = useTranslation();
  const { confirmDialogResult } = useModalConfirm();
  const [isModalOpen, setModalState] = useState(false);

  const showModalClick: MouseEventHandler<HTMLElement> = () => {
    setModalState(true);
  };

  const modalClosedClick = (): void => {
    setModalState(false);
  };

  const okClick = (): void => {
    alert("ok click");
  };

  const displayConfirmClick = async (): Promise<void> => {
    const conf = await confirmDialogResult({
      title: t("general.ARCHIVE_MESSAGE_ITEM_TITLE"),
      message: t("general.ITEM_ARCHIVE_MESSAGE"),
    });
    Log.debug("display confirm result", conf);
  };

  const openNotification = (): void => {
    Log.debug(`Notation check`);
  };

  return (
    <ButtonsTestPageWrapperStyled>
      <h1>Ryde ({t("general.CONFIRM")})</h1>
      Test Roboto
      <ArrowRight />
      <RobotoCondensedPanelStyled>
        Test Roboto Condensed
      </RobotoCondensedPanelStyled>
      <p>Confirm: ({t("general.CONFIRM")})</p>
      <p> +{t("general.ADD_A_NEW_ENTITY", { entity: "site" })}</p>
      <SVG_MUI.ArrowsToDottedLineSVG />
      <StyledModalButtonContainer>
        <MuiButton sx={{ m: 1 }} onClick={showModalClick}>
          Show modal
        </MuiButton>
        <MuiButton
          sx={{ m: 1 }}
          onClick={() => openNotification()}
          muiStyle="info"
        >
          Show confirm
        </MuiButton>
      </StyledModalButtonContainer>
      <StyledModalButtonContainer>
        <MuiButton
          sx={{ m: 1 }}
          onClick={() => displayConfirmClick()}
          muiStyle="warning"
        >
          Open notations
        </MuiButton>
      </StyledModalButtonContainer>
      <ModalDialog
        isModalOpen={isModalOpen}
        closeModalClick={modalClosedClick}
        saveClick={okClick}
        title={"Test modal"}
      >
        <DashboardModalContent />
        <DashboardModalContent />
      </ModalDialog>
    </ButtonsTestPageWrapperStyled>
  );
};
